import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AlertAction } from "@/components/AlertAction";
import { CreditCard, Landmark } from "lucide-react";

const Box = ({ testid, icon, children, cta, ctaTestid }) => <div className="compact-actions rounded-xl border border-amber-300 bg-amber-50 dark:bg-amber-950/30 px-3 py-2 flex items-center gap-2.5 min-h-[52px]" data-testid={testid}>
  <span className="shrink-0">{icon}</span>
  <p className="flex-1 min-w-0 text-xs sm:text-sm leading-snug line-clamp-2 sm:line-clamp-1">{children}</p>
  <AlertAction to="/app/ordina-sim" testid={ctaTestid}>{cta}</AlertAction>
</div>;

export const SimLowAlert = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/sim-stock/count").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return <>
    {d.pending_orders > 0 && <Box testid="sim-pending-alert" icon={<Landmark className="w-4 h-4 text-amber-600" />} cta="Vedi ordini" ctaTestid="sim-pending-alert-open">
      <strong>{d.pending_orders === 1 ? "Hai un ordine SIM da pagare." : `Hai ${d.pending_orders} ordini SIM da pagare.`}</strong> Appena confermiamo il bonifico le SIM arrivano nel tuo magazzino.</Box>}
    {d.low && !d.pending_orders && <Box testid="sim-low-alert" icon={<CreditCard className="w-4 h-4 text-amber-600" />} cta="Ordina SIM" ctaTestid="sim-low-alert-order">
      <strong>Non restare senza SIM!</strong> {d.stock ? `Ne hai solo ${d.stock} in magazzino.` : "Non hai SIM in magazzino per attivare nuovi clienti."}</Box>}
  </>;
};
